import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *, *::after, *::before {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background:
      radial-gradient(circle at top left, rgba(20, 191, 99, 0.13), transparent 28%),
      radial-gradient(circle at top right, rgba(96, 165, 250, 0.10), transparent 30%),
      ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: "Inter", "Segoe UI", sans-serif;
    transition: all 0.25s linear;
  }

  #root {
    width: 100%;
  }

  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
`;
